import { deserialize } from 'cerialize'

export class FunctionAliasModel {
	@deserialize public id: number
	@deserialize public name: string
	@deserialize public alias: string
	@deserialize public interface_element_slug: string
}
